var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueIcons0647(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.82,
    height: 17.562,
    viewBox: "0 0 26.82 17.562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BlueIcons_-06-47",
    "data-name": "BlueIcons -06-47",
    transform: "translate(-4.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    transform: "translate(5.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3747",
    "data-name": "Path 3747",
    d: "M54.611,8.781A8.755,8.755,0,1,1,45.855,0,8.772,8.772,0,0,1,54.611,8.781Z",
    transform: "translate(-33.077)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3748",
    "data-name": "Path 3748",
    d: "M67.608,25.691a5.557,5.557,0,0,0-2.037.633,2.16,2.16,0,1,1-2.682,3.315,5.666,5.666,0,0,0-.19,2.126,5.509,5.509,0,1,0,4.909-6.073Z",
    transform: "translate(-55.411 -22.414)",
    fill: "none",
    stroke: "#0561fc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749",
    "data-name": "Path 3749",
    d: "M18.079,23.7A16.073,16.073,0,0,0,5.3,29.469a16.091,16.091,0,0,0,12.779,5.769,16.073,16.073,0,0,0,12.779-5.769A16.111,16.111,0,0,0,18.079,23.7Z",
    transform: "translate(-5.3 -20.701)",
    fill: "none",
    stroke: "#0561fc",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueIcons0647);
export default __webpack_public_path__ + "static/media/BlueIcons -06-47.8e4581a5d12d193bd22c278a0c269358.svg";
export { ForwardRef as ReactComponent };